export default {
  'moduleTitle.address': 'כתובת',
  'moduleTitle.address_details': 'פרטי כתובת',
  'moduleTitle.activity_details': 'פרטי פעילות',
  'moduleTitle.add_log': 'הוסף/י פעילות',
  'moduleTitle.award_level': 'שלב',
  'moduleTitle.adventurous_journey': 'מסע אתגרי',
  'moduleTitle.already_assessed': 'כבר הוערך!',
  'moduleTitle.approved': 'מאושר!',
  'moduleTitle.assessor_details': 'פרטי מדריכ/ה',
  'moduleTitle.authorising_contact_license_holder': 'הגוף המאשר/ בעל הרשיון',
  'moduleTitle.category_journey_details': '{category} פרטי מסע',
  'moduleTitle.complete_report': 'השלם דיווח',
  'moduleTitle.completed_progress': 'הושלם {finished} / {total}',
  'moduleTitle.congratulation': 'ברכות!',
  'moduleTitle.confirming_email_address': 'מאשר כתובת דואר אלקטרוני ...',
  'moduleTitle.contact_details': 'פרטי התקשרות',
  'moduleTitle.edit_log': 'ערוך מידע',
  'moduleTitle.event_journey': '{event} מסע',
  'moduleTitle.forgotten_password': 'נשכחה סיסמה',
  'moduleTitle.great_you_are_almost_there': 'מדיניות פרטיות',
  'moduleTitle.home_address': 'כתובת מגורים',
  'moduleTitle.journey_overview': 'תיאור המסע',
  'moduleTitle.log_detail': 'פרטי רישום',
  'moduleTitle.login': 'התחבר/י',
  'moduleTitle.new_activity': 'פעילות חדשה',
  'moduleTitle.new_event_journey': 'מסע {event} חדש',
  'moduleTitle.new_residential_project': 'פרויקט קהילתי חדש',
  'moduleTitle.notRegistred': 'לא רשומ/ה?',
  'moduleTitle.nominated_award_leader_contact_details': 'פרטי התקשרות רכז/ת מועמד/ת',
  'moduleTitle.nominated_award_leader': 'ררכז/ת מועמד/ת',
  'moduleTitle.organisation_address': 'כתובת הארגון',
  'moduleTitle.organisation_details': 'פרטי ארגון',
  'moduleTitle.online_record_book_account': 'חשבון ה ORB',
  'moduleTitle.page_not_found': '404 - עמוד לא נמצא',
  'moduleTitle.personal_details': 'פרטים אישיים',
  'moduleTitle.preparation_and_training': 'הכנה והכשרה',
  'moduleTitle.profile_guardian_consent': 'אישור הורים / אפוטרופוס',
  'moduleTitle.profile_questions': 'שאלות פרופיל',
  'moduleTitle.registration_for_level': 'רישום לשלב הבא',
  'moduleTitle.residential_project': 'פרויקט קהילתי',
  'moduleTitle.residential_project_details': 'פרטי פרויקט קהילתי',
  'moduleTitle.reset_password': 'אפס סיסמה',
  'moduleTitle.welcome_to_the_orb': 'ברוכ/ה הבאה לאות"ה',
  'moduleTitle.we_have_sent_you_an_email': 'שלחנו לך הודעת דואר אלקטרוני עם קישור להפעלה',
  'moduleTitle.your_registration_is_complete': 'רישומך הושלם',
  'formTitle.activity_details': 'פרטי פעילות',
  'formTitle.assessor_details': 'פרטי מדריך/כה',
  'formTitle.supervisors_details': 'פרטי מפקח/ת',
  'formTitle.preparation_and_training_activities': 'פעילויות הכנה והכשרה',
  'formTitle.added_preparation_activities': 'פעילויות הכנה והכשרה נוספות',
  'label.add_picture': 'הוסף/פי תמונה',
  'label.address_first_line': 'כתובת',
  'label.address_second_line': 'כתובת - המשך (אופציונלי) ',
  'label.are_you_already_running_award': 'האם את/ה כבר פעיל/ה באות הנוער?',
  'label.are_you_the_main_award_leader': 'האם את/ה רכז/ת הסניף?',
  'label.award_participant': 'חניך/כת האות',
  'label.award_leader': 'רכז/ת',
  'label.birthdate': 'תאריך לידה',
  'label.category': 'קטגוריה',
  'label.change_locale': 'שנה מיקום',
  'label.choose_project': 'בחר פרויקט',
  'label.city': 'עיר',
  'label.choose_as_major_activity': 'בחר כפעילות ראשית',
  'label.date': 'תאריך',
  'label.date_of_birth': 'תאריך לידה',
  'label.description_of_progress': 'תיאור התקדמות אישית',
  'label.duration': 'משך פעילות (Hours / Mins)',
  'label.email': 'דואר אלקטרוני',
  'label.email_address': 'כתובת דואר אלקטרוני',
  'label.email_again': 'דואר אלקטרוני (שוב)',
  'label.employment_status': 'מצב תעסוקתי',
  'label.end_date': 'תאריך סיום',
  'label.enter_his_email': 'הכנס/י כתובת דואר אלקטרוני של הרכז/ת ',
  'label.entered_transaction_id': 'מספר האישור/אסמכתא שלך',
  'label.first_name': 'שם פרטי',
  'label.gender': 'מגדר',
  'label.goal': 'מטרה',
  'label.journey_activity': 'פעילות מסע',
  'label.journey_objective': 'יעדי מסע',
  'label.journey_observations': 'הבחנות מהמסע',
  'label.journey_type': 'סוג מסע',
  'label.last_name': 'שם משפחה',
  'label.level': 'שלב',
  'label.location': 'מיקום',
  'label.logout': 'התנתק/י',
  'label.major': 'תחום ראשי',
  'label.middle_name': 'שם אמצעי',
  'label.mode_of_transport': 'אמצעי תחבורה',
  'label.my_award_leader': 'הרכז/ת שלי',
  'label.name': 'שם',
  'label.nationality': 'לאום',
  'label.no': 'לא',
  'label.no_results': 'אין תוצאות',
  'label.note': 'הערה',
  'label.note_for_assessor': 'הערה למדריכ/ה',
  'label.note_for_leader': 'הערה לרכז/ת',
  'label.optional': 'אופציונלי',
  'label.organisation_name': 'שם הארגון',
  'label.organisation_type': 'סוג הארגון',
  'label.others': 'שונות',
  'label.password': 'סיסמה',
  'label.password_again': 'חזור/י על הסיסמה',
  'label.project_location': 'מיקום הפרויקט',
  'label.pay_online': 'לתשלום מקוון',
  'label.pay_award_leader_or_unit': 'העברת התשלום לרכז/ת או למדריך/כה',
  'label.payment_not_required': 'לא נדרש תשלום מהחניך/כה',
  'label.payment_type': 'סוג התשלום:',
  'label.phone': 'טלפון',
  'label.phone_number': 'מספר טלפון',
  'label.phone_type': 'סוג הטלפון\n',
  'label.profile': 'פרופיל',
  'label.reset_password': 'אפס/י סיסמה',
  'label.region': 'מדינה/ אזור/ מחוז',
  'label.relationship': 'קשר',
  'label.role_in_organisation': 'תפקיד בארגון',
  'label.select_country': 'בחר/י מדינה',
  'label.select_your_au': 'בחר/י את הסניף שלך',
  'label.start_typing': 'החל/י להקליד',
  'label.start_date': 'תאריך התחלה',
  'label.select': 'בחר/י',
  'label.select_async': 'החל/י להקליד...',
  'label.select_your_operating_authority': 'בחר/י את הסמכות התפעולית שלך',
  'label.specify_category': 'אנא ציין/ני את הקטגוריה שלך',
  'label.subcategory': 'קטגוריית משנה',
  'label.title': 'תואר',
  'label.username': 'שם משתמש/ת',
  'label.what_is_your_role': 'מה תפקידך בארגון?',
  'label.where_have_you_completed': 'היכן השלמת?',
  'label.yes': 'כן',
  'label.your_changes_havent_been_saved': 'השינויים שהזנת לא נשמרו. מידע יאבד',
  'label.zip': 'מיקוד',
  'label.adventurous_journey': 'מסע אתגרי',
  'label.after_your_journey_describe': 'תאר/י התרשמותך מהמסע האתגרי במספר משפטים.',
  'label.because_your_age_is_under_18': 'כיוון שהינך מתחת לגיל 18, אנו זקוקים לאישור הורה/ אפוטרופוס.',
  'label.before_you_head_to_journey': 'לפני שתוכל/י להמשיך עם מסע מעבר השלב, עליך קודם להשלים הכנות והכשרות',
  'label.before_entering_new_level': 'לפני שאת/ה מתחיל/ה את השלב הבא, אנא אשר/י את נכונות פרטיך האישיים.',
  'label.bring_required_amount_to_your_award_leader': 'הבא/הביאי סכום נדרש למדריך/כה או לרכז/ת בסניפך.',
  'label.do_you_have_any_other_level': 'האם השלמת שלבים קודמים באות הנוער?',
  'label.do_you_know_who_is_your_award_leader': 'האם את/ה יודע/ת מי הרכז/ת שלך?',
  'label.going_on_an_expedition': 'יציאה למשלחת נותנת לך את ההזדמנות להרפתקה, לחוות עבודת צוות ולפעול בצורה יוזמת ועצמאית.',
  'label.going_on_residential_gives_chance': 'פרויקט קהילתי מעניק לך הזדמנות ללמוד לעבוד עם אנשים מרקעים שונים ולהתנסות בחיים בסביבה לא מוכרת. ',
  'label.i_confirm_that_i_meet': 'אני מאשר/ת שאעמוד בכל דרישות המפעיל הארצי.',
  'label.i_agree_to_volunteer_code': 'אני מסכימ/ה לקוד ההתנהגות ההתנדבותי. למידע נוסף לחצ/י כאן.',
  'label.i_have_read_the_terms_and_conditions': 'קראתי ואישרתי את התנאים הכללים.',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'אעביר את האישור לרכז/ת במועד מאוחר יותר',
  'label.if_you_are_from_orphanage': 'לדוגמה, אם המועצה או ארגון הנוער משלם בשמך.',
  'label.here_you_can_add_activity': 'כאן את/ה יכול להוסיף פעילות הכנה או הכשרה נוספת.',
  'label.how_do_you_want_to_apply': 'איך תרצה/י להגיש את אישור ההורים/ אפוטרופוס',
  'label.my_parent_consent_has_been_already_given': 'אישור ההורים/ אפוטורופוס שלי כבר הוגש למדריך שלי.',
  'label.my_parent_will_confirm_consent_by_email': 'אישור ההורים/ אפוטרופוס ישלח בדואר אלקטרוני',
  'label.major_activity_means_that_you_have_to_spent': 'משמעותה של פעילות ראשית היא שיש להשקיע פי שניים זמן בפעילות זו ביחס לפעילויות האחרות.',
  'label.not_sure_about_your_auth': 'לא בטוח/ה מי הרכז/ת שלך? צור עימנו קשר ב',
  'label.page_not_found': '404 - דף לא נמצא',
  'label.please_fill_in_the_following': 'אנא מלא/י את הפרטים הבאים לרכז/ת או מנהל/ת בארגון שלך.',
  'label.register_a_new_account_as': 'הירשם/מי לחשבון חדש כ:',
  'label.residential_project': 'פרויקט קהילתי',
  'label.select_your_award_unit': 'בחר/י את הסניף שלך',
  'label.the_expedition_can_be_faraway': 'המשלחת יכולה להיות רחוקה או קרובה לביתך כרצונך, ויכולות להיות המון דרכים להשתתף.',
  'label.to_log_your_process_on_orb': 'כדי להשלים את הרשמתך לאות"ה אנא צור/צרי סיסמה.',
  'label.waiting_for_assessment': 'ממתין להערכה.',
  'label.waiting_for_sign_off': 'ממתין לאישור רכז/ת',
  'label.we_have_sent_you_an_email': 'שלחנו לך הודעת דואר אלקטרוני עם קישור להפעלה',
  'label.what_level_of_the_award': 'לאיזה שלב את/ה נרשמ/ת?',
  'label.you_are_now_registering_as_participant': 'את/ה כעת נרשמת כחניכ/ה באות הנוער.',
  'label.you_are_now_registering_as_award_unit': 'את/ה כעת נרשמ/ת כסניף של אות הנוער.',
  'label.you_can_use_my_photos_for_promotional_purposes': 'כחניך/ה באות הנוער, אני מאשר/ת לארגון להשתמש בתמונות שלי למטרות שיווקיות.',
  'label.you_can_send_activity_for_approval': 'כעת את/ה יכול/ה לשלוח את רישום הפעילות שלך למדריך/ה לאישור.',
  'label.you_can_send_activity_for_leader': '\nכעת את/ה יכול/ה לשלוח את רישום הפעילות שלך לרכז/ת לאישור.',
  'label.you_can_send_residential_project_to_leader': 'כעת את/ה יכול לשלוח את הפרויקט הקהילתי שלך לרכז/ת לאישור.',
  'label.you_have_finished_now_send_to_approval': 'פעילותך הסתיימה. כעת את/ה יכול/ה להגישה למדריך/ה שלך לאישור. יש לך אפשרות להוסיף הערה אישית מתחת.',
  'label.preparation_and_training': 'אימונים והכנות',
  'label.you_will_be_redirected_to_the_payment': 'את/ה תופנה/י לדף תשלום, שם תוכל/י לשלם באמצעות כרטיס אשראי. ',
  'label.you_will_be_the_first_award_leader': 'את/ה תהיה הרכז/ת הראשונ/ה בארגונך. תהיה לך האפשרות להוסיף מדריכים/ות נוספים/ות, חניכים ולנהל את תהליך מעבר השלב באמצעות האות"ה.',
  'label.youll_receive_a_notification': ' תקבל/י התראה כאשר הרכז/ת תאשר/יאשר את רישומך. את/ה יכול/ה להינכס לאות"ה <a>here</a> (עד אשר הרכז/ת אישר/ה את הרשמתך, תהיה לך אפשרות שימוש מוגבלת במערכת).',
  'label.your_parent_email': 'כתובת הדואר האלקטרוני של הוריך',
  'label.your_parent_first_name': 'שם ההורה',
  'label.your_parent_last_name': 'שם ההורה',
  'label.your_report_approve_now_send_to_leader': 'הדיווח שלך אושר על ידי המדריכ/ה. כעת את/ה יכול להגיש אותו לרכז/ת לאישור. את/ה יכול/ה להוסיף הערה אישית מתחת.',
  'label.there_are_loads_of_exciting_possibilities': 'יש המון אפשרויות והזדמנויות מרגשות. בחר/י את זו המתאימה לך ביותר. ',
  'label.your_residential_project_has_been_setup': 'הפרויקט הקהילתי שלך הוגדר ונשלח לרכז/ת לאישור.',
  'label.your_report_has_been_sent_assessor': 'הדיווח שלך נשלח למדריך/ה לאישור.',
  'label.your_report_has_been_sent_leader': 'הדיווח שלך נשלח לרכז/ת שלך לאישור.',
  'label.your_residential_project_is_complete': 'הפרויקט הקהילתי שלך הושלם.',
  'label.to_work_on_the_online': 'כדי לעבוד על מערכת האות"ה את/ה זקוק/ה לחשבון.',
  'label.we_will_send_you_an_email': 'יישלח אליך דוא"ל כאשר רישום חשבון האות"ה שלך יאושר.',
  'label.if_you_have_any_problems_or_doubts': 'אם יש לך קשיים או ספקות אנא צור קשר עם הסניף שלך למידע נוסף.',
  'label.are_you_sure_you_want_to_leave': 'את/ה בטוח/ה שאת/ה רוצה לעזוב? מידע יאבד',
  'label.no_logs_yet': 'אין רישומים. <br /> להוספת רשומה לחץ על "הוסף רישום".',
  'label.menu': 'תפריט',
  'notifications.award_unit_has_been_created': 'סניף נוצר',
  'notifications.authorization_code_is_not_valid': 'קוד אישור לא בתוקף',
  'notifications.email_has_been_confirmed': 'כתובת דואר אלקטרוני אושרה',
  'notifications.leader_has_been_created': 'נוצר/ה רכז/ת',
  'notifications.participant_has_been_created': 'נוצר/ה חניך/ה',
  'notifications.email_with_instructions_has_been_sent': 'הודעת דואר אלקטרוני עם הנחיות נשלחה',
  'notifications.your_new_password_has_been_set': 'סיסמתך החדשה הוגדרה',
  'notifications.success': 'הצלחה',
  'notifications.unknown_role': 'כלל לא ידוע',
  'notifications.waiting_for_approval': 'ממתין לאישור',
  'notifications.activity_cannot_be_created': 'פעילות לא יכולה להיקלט עד אשר ההרשמה אושרה',
  'notifications.new_activity_has_been_added': 'פעילות חדשה הוספה',
  'notifications.new_log_has_been_added': 'דיווח חדש הוסף',
  'notifications.log_has_been_deleted': 'דיווח הוסר',
  'notifications.log_has_been_modified': 'דיווח עודכן',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'לא ניתן ליצור מסע עד שרישומך יושלם ויאושר',
  'notifications.new_participant_event_has_been_added': 'האירוע החדש הוסף',
  'notifications.participant_event_has_been_completed': 'האירוע הושלם',
  'notifications.training_and_practice_modified': 'אימון והכשרה ושונו',
  'notifications.completion_residential_project_completed': 'הפרויקט הקהילתי הושלם',
  'notifications.new_residential_project_has_been_added': 'פרויקט קהילתי חדש הוסף',
  'notifications.residential_project_cannot_be_created_until_approved': 'לא ניתן ליצור פרויקט קהילתי עד לאישור ההרשמה',
  'notifications.already_assessed_sent': 'נשלחה בקשה לאישור מדריך/ה',
  'notifications.assessment_request_sent': 'בקשה להערכה נשלחה',
  'notifications.leader_approval_sent': 'בקשה לקבלת אישור מדריך נשלחה',
  'tabs.logs': 'תיעוד פעילות\n ',
  'tabs.new': 'חדש',
  'tabs.overview': 'יעדים',
  'tabs.report': 'דווח/י',
  'button.add_activity': 'הוסף/הוסיפי פעילות',
  'button.add_log': 'הוספת פעילות\n',
  'button.continue_here': 'המשך/המשיכי כאן',
  'button.continue': 'המשך/המשיכי',
  'button.continue_to_award': 'המשך/המשיכי לאות',
  'button.delete': 'מחיקה',
  'button.edit': 'עריכה',
  'button.edit_log': 'עריכת רישום',
  'button.finish': 'סיום',
  'button.forgot_your_password': 'שכחת סיסמה?',
  'button.i_already_have_assessment': 'יש ברשותי הערכה',
  'button.leave_anyway': 'לעזוב בכל זאת',
  'button.login': 'כניסה',
  'button.no': 'לא',
  'button.register': 'הרשמה',
  'button.send': 'שלח/י',
  'button.send_for_approval': 'שלח/י לאישור',
  'button.setup': 'הגדרה',
  'button.setup_residential': 'הגדרת פרויקט קהילתי',
  'button.stay': 'הישאר/י',
  'button.submit': 'הגשה',
  'button.update': 'עידכון',
  'button.yes': 'כן',
  'errors.at_least_num_characters': 'לפחות {length} תווים',
  'errors.do_not_match': 'לא תואם',
  'errors.include_at_least_one_number': 'עלייך לכלול לפחות סיפרה אחת',
  'errors.include_both_lower_and_upper_case': 'יש לכלול אותיות רישיות ואותיות קטנות.',
  'errors.invalid_phone_format': 'פורמט מספר הטלפון לא תקין',
  'errors.invalid_email_address': 'פורמט כתובת המייל לא תקין',
  'errors.required_field': 'שדה חובה',
  'errors.must_be_at_least': 'חייב להכיל לפחות {min} תוים',
  'errors.must_be_no_more_than': 'חייב להיות קצר מ{max} תוים',
  'errors.must_be_an_integer': 'חייב להיות מספר שלם',
  'errors.must_contain_at_least': 'חייב לכלול לפחות סיפרה אחת',
  'errors.must_include_at_least': 'חייב להכיל לפחות אות גדולה אחת',
  'errors.must_be_one_of': 'חייב להיות אחד מ{enums}',
  'errors.you_must_be_younger_than': 'עליך להיות צעיר מ {years} שנים ו {months} חודשים בכדי להירשם לאות הנוער. אנא פנה/י לאחראי בסניף המקומי',
  'errors.you_must_be_older_than': 'עליך להיות צעיר מ {years} שנים ו {months} חודשים בכדי להירשם לאות הנוער. אנא פנה/י לאחראי בסניף המקומי',
  'errors.email_address_is_in_use_please_sign': 'כתובת המייל כבר בשימוש. במידה ואת/ה רוצה להירשם לשלב חדש, אנא היכנס/י לחשבונך',
  'errors.email_address_is_in_use': 'כתובת המייל כבר בשימוש',
  'errors.sorry_we_already_have_this_email': "מצטערים, כבר קיים במערכת שם משתמש עם כתובת דוא\"ל זו. להתחלת השלב הבא <a href='/'> התחבר לחשבונך </a> ובחר באפשרות התחל בשלב הבא",
  'wizard.authorising_contact': 'פרטי המאשר',
  'wizard.award_leader_contact': 'פרטי הרכז/ת',
  'wizard.award_unit_details': 'פרטי סניף',
  'wizard.contact_details': 'פרטי אנשי קשר',
  'wizard.contacts': 'אנשי קשר',
  'wizard.level': 'שלב האות',
  'wizard.level_selection': 'בחירת האות',
  'wizard.leader_details': 'פרטי המדריכים/ות',
  'wizard.nominated_award_leader': 'מדריכים/ות מועמדים/ות',
  'wizard.orb_account': 'חשבון אות"ה',
  'wizard.parent_consent': 'הסכמת ההורים',
  'wizard.participant_details': 'פרטי החניכ/ה',
  'wizard.profile': 'פרופיל',
  'wizard.payment': 'תשלום',
  'wizard.select_award_unit': 'יש לבחור סניף',
  'wizard.unit_details': 'פרטי הסניף',
  'wizard.welcome': 'ברוכ/ה הבא/ה',
  'wizard.your_details': 'פרטייך',
  'awardUnit.do_you_want_to_create': 'האם ברצונך להגדיר סניף חדש?',
  'parent.you_can_download_the_consent_here': "תוכל להוריד כאן את טופס 'אישור הורים' אם הוא טרם נמצא ברשותך , החתם את הוריך והשב אותו חתום למדריך.",
  'footer.copyright': "והעתקה; כל הזכויות שמורות ל'אות הבינלאומי של הדוכס מאדינברו' {year}",
  'registration_participant.required_award_payment': 'דרוש תשלום לאות',
  'registration_participant.pay_online_here': 'שלם/י אונליין וקבל/י את מזהה התשלום כאן',
  'dashboard.activity_log_time': '{hours}ש {minutes}ד',
  'moduleTitle.award_completed': 'האות הושלם!',
  'notifications.award_approval_request_sent_to_leader': 'בקשה לאישור האות נשלחה למדריך שלך',
  'notifications.new_participant_event_has_been_completed': 'פעילות חניך/ה אושרה ע"י המדריך/ה',
  'notifications.preparation_and_training_approval_sent': 'אישור על ההכנות לפעילות נשלח',
  'notifications.reparation_and_training_completed': 'הכנות ואימונים לפעילות אושרו',
  'notifications.your_profile_photo_has_been_edited': 'תמונת הפרופיל שלך נערכה',
  'notifications.your_profile_has_been_edited': 'הפרופיל שלך נערך',
  'notifications.new_level_has_started': 'השלב הבא החל',
  'notifications.activity_has_been_edited': 'הפעילות נערכה',
  'notifications.you_have_been_logged_out': 'מתנתק..',
  'notifications.logging_out': 'יצאת מחשבונך',
  'label.you_can_send_award_to_leader': 'ניתן לשלוח כעת את האות לרכז/ת לאישור',
  'label.you_have_completed_all_sections_of_your_award': 'השלמת את כל התחומים לקבל ה"אות". באפשרותך לשלוח את ה"אות" לאישור הרכז/ת. באפשרותך להוסיף הערה אישית למטה',
  'label.you_have_now_completed_your_award': 'כעת השלמת את {level} שלך ב"אות". האם ברצונך להמשיך לשלב הבא?',
  'label.congratulation_your_award_has_been_approved': 'ברכותינו. אות {level} שלך אושר! באפשרותך להתקדם לשלב הבא ',
  'moduleTitle.settings': 'הגדרות',
  'moduleTitle.edit_activity': 'עריכת פעילות',
  'moduleTitle.select_your_major_activity': 'בחר/י את הפעילות הראשית שלך',
  'label.settings': 'הגדרות',
  'label.major_activity_means_that_you_will': 'התחום העיקרי- הכוונה לתחום בו אתה מעדיף להתמקד ולהקדיש יותר שעות פעילות משאר התחומים. בשלב הכסף והזהב מדובר על זמן נוסף של 6 חודשים, בשלב הארד, זמן נוסף של 3 חודשים.',
  'label.notifications': 'התראות',
  'label.my_award': 'האות שלי',
  'label.physical_recreation': 'תחום הספורט',
  'label.skill': 'מיומנות/תחביב',
  'label.service': 'התנדבות בקהילה',
  'label.my_parent_will_complete_and_sign_form': 'ההורה/האפוטרופוס שלי ימלא את טופס האישור ויחתום עליו.',
  'label.please_print_it_tak_it_to_your_parent': 'אנא הדפס/י, העבר/י להורייך לחתימה והעבר/י למדריכ/ה שלך',
  'label.change_password': 'שינוי סיסמה',
  'label.change_major_activity': 'שינוי הפעילות הראשית שלך',
  'title.change_password': 'סינוי סיסמה',
  'label.old_again': 'סיסמה קודמת',
  'label.new_password': 'סיסמה חדשה',
  'label.new_password_again': 'וידוא סיסמה חדשה',
  'errors.passwords_dont_match': 'הסיסמה אינה תואמת',
  'errors.more_than': 'יותר מ {limit}',
  'button.parent_guardian_consent_pdf': 'אישור הורים PDF',
  'button.send_award_for_approval': 'שלח/י את האות לאישור',
  'button.send_report': 'שלח/י דיווח',
  'button.terms_and_conditions': 'תנאים כללים - בינלאומי',
  'button.privacy_policy': 'מדיניות פרטיות',
  'button.save': 'שמירה',
  'button.start_new_level': 'התחלת השלב הבא',
  'button.change_password': 'שינוי סיסמה',
  'button.edit_activity': 'עריכת פעילות',
  'moduleTitle.file_upload': 'העלאת קובץ',
  'label.add_file': 'הוספת קובץ',
  'label.description': 'תיאור',
  'label.waiting_for_office_sign_off': 'בהמתנה לאישור הסניף',
  'notifications.file_has_been_uploaded': 'הקובץ הועלה',
  'tabs.files': 'קבצים',
  'button.upload': 'העלאה',
  'button.upload_file': 'העלאת קובץ',
  'button.add_file': 'הוספת קובץ',
  'button.this_activity_has_no_assessor': 'לפעילות זו איו שיוך מדריך/ה. עליך להזין למערכת פרטי מדריך/ה לפני משלוח לאישור הפעילות.',
  'label.i_want_to_register_my_award': 'ברצוני לרשום את הסניף כיחידת אות עצמאית - לא רלבנטי',
  'label.select_sub_operating_authority': 'יש לבחור מפעיל משנה',
  'label.your_must_first_setup_some_activity': 'ראשית עליך להגדיר פעילות',
  'label.you_cant_change_your_major_activity': 'לא ניתן לשנות את הפעילות הראשית. הפעילות הראשית כבר הושלמה.',
  'label.s_specific': '<b>S-Specific: על המטרה שלך להיות ממוקדת, ולא כללית מדי. במקום להגדיר: אני רוצה להשתפר בנגינה בכינור, עדיף להגדיר: הייתי רוצה ללמוד 3 יצירות חדשות לכינור',
  'label.m_measurable': '<b>M-Measurable: מדיד. עליך להיות מסוגל לדעת כאשר הגעת למטרה שלך. </b> במקום להגדיר מטרות כגון: אני רוצה לעזור לקהילה, אפשר להגדיר: אני רוצה לעזור בחלוקת מזון פעם בשבוע. בדרך זו, ניתן לבחון האם המטרות הושגו.',
  'label.a_achievable': "<b>A-Achievable: ניתן להשגה: המטרה שלך חייבת להיות מושגת בתקופת השלב הנוכחית שלך ב'אות הנוער'. לשם כך עליך להציב מטרות מעשיות. לדוגמה, מטרה לא מעשית ושלא ניתנת להשגה היא : \"אני רוצה להביא סוף לרעב בעולם\". דוגמה מטרה מעשית וניתנת להשגה:  'אני רוצה לגייס כסף לטובת מוסד שעוזר לאנשים במצוקה כספית'. ",
  'label.r_realistic': "מציאותי: דומה ל'ניתן להשגה':  </b> האם המטרה שלי מציאותית? האם אצליח להגשים את המטרות שלי במסגרת הזמנים שעומדת לרשותי?",
  'label.t_timely': 'מתוזמן:עליך להגדיר מהו תאריך היעד להשלמת המטרה שהגדרת. לדוגמה: "אני רוצה ללמוד 200 מלים בספרדית תוך חודשיים".',
  'label.you_can_upload_here_any_files': 'ניתן להעלות כאן כל קובץ שאת/ה מעוניינ/ת לחלוק עם הרכז/ת שלך',
  'moduleTitle.login_change': 'שינוי הגדרת כניסה למערכת',
  'notifications.adventurous_journey_modified': 'מסע אתגרי שונה',
  'tabs.sections': 'תחומים',
  'label.change_email': 'שינוי כתובת המייל',
  'title.change_email': 'שינוי כתובת המייל',
  'label.new_email': 'כתובת מייל חדשה',
  'label.new_email_again': 'אישור כתובת המייל החדשה',
  'errors.emails_dont_match': 'כתובות המייל לא תואמות',
  'button.change_email': 'שינוי כתובת מייל',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'אימייל ובו הוראות נשלח אל כתובת המייל שלך',
  'global.dofe_name': 'האות הבינלאומי לנוער של הדוכס מאדינברו',
  'global.or': 'או',
  'route.landing_page': 'דף נחיתה',
  'route.dashboard': 'לוח מכוונים',
  'moduleTitle.notifications': 'התראות',
  'moduleTitle.no_notifications': 'ללא התראות',
  'moduleTitle.new_notifications': 'התראות חדשות',
  'moduleTitle.older_notifications': 'התראות קודמות',
  'moduleTitle.user_guide': 'מדריכים למשתמש/ת',
  'label.user_guide': 'מדריך למשתמש/ת',
  'notifications.your_password_has_been_changed': 'הסיסמה שונתה בהצלחה',
  'label.country': 'מדינה',
  'label.on_your_smartphone': 'בסמארטפון שלך',
  'label.on_the_web': 'באינטרנט',
  'label.orb_online': 'אות"ה באינטרנט',
  'label.language': 'שפה',
  'moduleTitle.participant_login': 'התחברות חניכים/ת',
  'label.for_ios': 'לIOS ',
  'label.for_android': 'עבור אנדרואיד',
  'button.login_as_award_staff': 'התחברות בעלי/ות תפקידים',
  'errors.leader_doesnt_exist': 'מדריך/ה לא קיים/ת',
  'global.loading': 'מעלה',
  'moduleTitle.award_staff_login': 'התחבר כאיש/ת צוות',
  'formTitle.residential_project_details': 'פרטי פרויקט מקומי',
  'label.you_can_also_download_participant': "באפשרותך להוריד את<strong>אפליקציית<strong/>החניכים של מערכת 'אות\"ה' לגישה מהירה בכל זמן, מכל מקום.",
  'label.you_can_also_download_leader': "באפשרותך להוריד את<strong>אפליקציית<strong/> המדריך של מערכת 'אות\"ה' לגישה מהירה בכל זמן, מכל מקום.",
  'notifications.this_role_is_not': 'התפקיד הזה לא מאויש כרגע',
  'notifications.residential_project_has_been_updated': 'הפרויקט הקהילתי הועלה בהצלחה',
  'tabs.participant': 'חניך/ה',
  'tabs.award_staff': 'סגל/צוות האות',
  'moduleTitle.edit_residential_project': 'עריכת הפרויקט הקהילתי',
  'button.residential_project': 'עריכת הפרויקט הקהילתי',
  'notifications.your_login_email_has_been_changed': 'כתובת הדואר האלקטרוני להתחברות שונתה',
  'meta.dofe_name': 'האות הבינלאומי של הדוכס מאדינבורו',
  'notifications.unknown_role_leader': 'תפקיד לא קיים - התחבר כאיש/ת צוות',
  'notifications.unknown_role_participant': 'תפקיד לא קיים - התחבר כמשתתף',
  'label.user_guide_web_participant': 'מדריך למשתמש/ת - משתתף',
  'label.user_guide_app_participant': 'מדריך משתמש לאפליקציה - משתתף',
  'label.note_for_supervisor': 'הערה למפקח/ת',
  'label.before_submitting_your_aj': 'לפני משלוח פרטי המסע לרכז/ת, עליך קודם לקבל אישור מ{role}. ניתן להוסיף הערה אישית עם משלוח הנתונים. ',
  'button.back_to_home': 'לעמוד הבית',
  'moduleTitle.assessor_approval': '{role} אישור',
  'label.this_aj_has_no_assessor': 'למסע הזה אין {role}. עליך לעדכן נתונים לפני משלוח לאישור. ',
  'route.not_found': 'לא נמצא',
  'notifications.are_you_sure': 'בטוח/ה?',
  'button.cancel': 'ביטול',
  'label.add_document': 'הוספת קובץ',
  'errors.there_are_currently_no_details_for_your': 'כרגע אין פרטים על {role} שלך. יש למלא את הפרטים החסרים לפני הגשת הפעילות לבדיקה',
  'moduleTitle.missing_data': 'חסר מידע',
  'label.to_send_assessment_request': 'במידה וברצונך לשלוח בקשה לבדיקה במייל, נא מלא/י את  דוא"ל ה {role} ',
  'label.pending_changes': 'השינויים בהמתנה...',
  'label.some_fields_require': 'חלק מהשדות מצריכים את התייחסותך',
  'roles.assessor': 'מדריך/ה',
  'roles.supervisor': 'אחראי/ת',
  'pageTitle.register_participant': 'חניך/ה רשום/ה',
  'moduleTitle.revise_message': 'תיקון הודעה',
  'moduleTitle.payment_for_level': 'תשלום עבור {awardLevel}',
  'moduleTitle.payment': 'תשלום דמי רישום',
  'moduleTitle.we_have_sent_you_payment_link': 'שלחנו לך מייל עם קישור לביצוע תשלום. ',
  'label.required_award_payment': 'נדרש תשלום דמי השתתפות',
  'label.payment_fees': 'דמי תשלום ',
  'label.payment_method': 'דרכי תשלום',
  'label.you_will_type_trans_id': 'תתבקש/י למלא את מספר האישור לתשלום',
  'label.any_level_previously': 'כל שלב',
  'label.registering_for_level': 'כל שלב שהושלם בעבר',
  'notification.payment_link_expired': 'פג תוקפו של הקישור לתשלום ',
  'button.pay': 'לתשלום',
  'label.registration_updated': 'הרישום שלך עודכן, הינך ראשי לסגור עמוד זה',
  'label.award_leader_receive_payment': 'הרכז/ת שלך יקבל את המידע על התשלום',
  'errors.end_date_after': 'תאריך הסיום חייב להיות לאחר תהליך ההתחלה',
  'button.back': 'אחורה',
  'button.edit_info': 'עריכת מידע',
  'moduleTitle.level_detail': 'פרטי שלב',
  'label.payment_methods': 'צורת התשלום',
  'label.address': 'כתובת',
  'note.review_filled_participant': 'אני בדוק/י את המידע שהוזן ע"י החניך/ה. במידה וישנן שגיאות באפשרותך לערוך מחדש',
  'moduleTitle.payment_successful': 'דמי הרישום לחניך עודכנו בהצלחה',
  'button.proceed_to_login': 'להתחברות- המשך/י',
  'label.add_additional_activity': 'הוסף/י פעילות חדשה',
  'moduleTitle.welcome_to_orb': 'ברוכים הבאים למערכת אות"ה',
  'empty_dashboard.not_approved': 'המערכת הזו תאפשר לך לעדכן את פעילותך והתקדמותך לאורך השלבים באות הנוער. לפני שתוכל/י ליצור את הפעילות הראשונה, עליך לעדכן את פרטי הרכז/ת שלך ולחכות לאישור.',
  'empty_dashboard.approved_1': 'המערכת הזו תוכל לסייע לך לתעד את ההתקדמות שלך לאור ה"אות" שלך',
  'empty_dashboard.approved_2': 'ראשית כל, עליך להגדיר את הפעילות שלך. כדי להתחיל, יש ללחוץ על אחד מתחומים בצד שמאל. במידה והינך זקוק/ה לעזרה, אנא פנה/י למדריך שלך לסיוע.',
  'label.discuss_activity_leader': 'אם ברצונך לבחור יותר מפעילות אחת, עליך לדבר על כך לפני כן עם המדריך/ה שלך. ',
  'label.cannot_add_activity': 'ניתן להוסיף 3 פעילויות לכל היותר בקטגוריה זו. יש לדבר על כך עם המדריך/ה שלך. ',
  'button.ok': 'אוקיי',
  'label.payment_was_canceled': 'התשלום בוטל על ידי המשתמש',
  'label.problem_with_payment': 'היתה בעיה בהעברת התשלום. יש ליצור קשר עם משרדי המטה. ',
  'pageTitle.register_leader': 'רישום מדריך/ה',
  'pageTitle.registration_complete': 'רישום הושלם',
  'label.payment_link_expired_or_paid': 'כבר שילמת עבור הרישום או שפג תוקף הקישור לתשלום.',
  'label.contact_nao_assistance': 'לסיוע ניתן לפנות למשרדי המטה. ',
  'label.send_required_amount_to_your_award_leader': 'העבירי/העבר סכום נדרש לרכז הסניף או למדריך/ה שלך. ',
  'label.fee_can_be_paid': 'ניתן לשלם אונליין באמצעוות כרטיסי אשראי מסוג ויזה, ישראכרט, מאסטרכרד, אמריקן אקספרס ולאומי קארד. ',
  'notifications.login_failed_right_tab': 'התחברות נכשלה. יש לוודא שהינך מתחבר/ת במשבצת הנכונה ((חניך/ה / צוות)',
  'label.i_have_read_privacy_policy': 'קראתי את מדיניות הפרטיות ואני מאשר/ת אותה',
  'errors.invalid_date_format': 'מבנה תאריך לא תקין',
  'label.no_privacy_policy': 'באפשרותך להמשיך ע"י לחיצה על כפתור "סיום"',
  'label.status': 'סטטוס',
  'moduleTitle.attached_with_observation': 'מצורף עם תצפית',
  'moduleTitle.revise_message_rp': 'מסע החקר שלך הוערך ע"י הרכז/ת שלך',
  'file.activity_section_summary': '{section} סיכום מקטע',
  'label.download_section_summary': 'הורדת סיכום מקטע פעילות',
  'label.award_summary': 'סיכום שלב',
  'btn.download_summary_for_assessor': 'הורדת סיכום למדריך/ה',
  'label.first_activity_started': 'פעילות ראשונה החלה',
  'label.hours_completed_required': 'שעות שהושלמו/נדרשות',
  'label.weeks_completed_required': 'שבועות הושלמו/נדרשים',
  back_to_home: 'חזרה לעמוד הבית',
  'label.activity_rejected_click': 'הפעילות שלך נדחתה ע"י הרכז/ת שלך. הקש/הקישי למידע נוסף.',
  'button.more_information': 'מידע נוסף',
  'label.attached_file': 'קובץ מצורף',
  'moduleTitle.journey_details': 'פרטי מסע',
  'tabs.activity': 'פעילות',
  'label.confirm_email': 'לאישור כתובת דואר אלקטרוני',
  'label.aj_rejected_click': 'המסע שלך נדחה על ידי הרכז/ת שלך. הקש/הקישי למידע נוסף',
  'label.verifying_payment': 'מאשר תשלום',
  'button.finish_and_pay': 'לסיום ולתשלום',
  'label.payment_not_successful_text': 'טרם הסדרת את דמי הרישום. יש לבצע את התשלום כעת. ',
  'label.payment_not_completed': 'תשלום לא הושלם',
  'button.pay_now': 'לתשלום עכשיו',
  'label.registration_pending_parental_consent': 'הרישום שלך ממתין לאישור הורה/ אפוטרופוס',
  'button.edit_observation': 'עריכת תצפית',
  'moduleTitle.qualifying': 'מסמיך',
  'moduleTitle.practice': 'אימון',
  'label.first_log_entry': 'רישום ראשון',
  'label.first_log_entry_date': 'תאריך רישום ראשון',
  'label.last_log_entry': 'רישום אחרון',
  'label.last_log_entry_date': 'תאריך רישום אחרון',
  'label.you_can_send_journey_report_for_approval': 'באפשרותך לשלוח את דו"ח המסע {journey} שלך לאישור',
  'button.edit_and_resend_report': 'לעריכה ולמשלוח מחדש של הדיווח',
  'label.your_journey_is_complete': 'המסע {journeyType} הושלם',
  'button.add_additional_journey': 'להוספת מסע נוסף',
  'moduleTitle.edit_journey': 'עריכת מסע',
  'notifications.assessment_sent': 'הערכה נשלחה',
  'notifications.file_is_too_big': 'לא ניתן להעלות את הקובץ. כנראה שהקובץ גדול מדי',
  'notifications.authorization_code_has_expired': 'פג תוקף קוד הארגון ',
  'route.confirm_email': 'אשר/י דוא"ל ',
  'label.assessor_needs_account': 'כדי לעבוד על מערכת האות"ה יש ליצור חשבון אישי. אנא צור/צרי חשבון כאן.',
  'label.company_name': 'שם החברה',
  'label.secondary_email_again': 'אשר/י תיבת דוא"ל חלופית',
  'label.how_many_years': 'כמה שנים/ חודשים?',
  'label.no_company_leave_empty': 'במידה ואינך עובד/ת בשום חברה, השאירי ריק',
  'label.secondary_phone_number': 'מספר טלפון חלופי',
  'label.secondary_phone_type': 'סוג טלפון חלופי',
  'label.wwc_application_number': '',
  'label.wwc_expiration_date': '',
  'label.you_are_now_registering_as_assessor': 'הינך רשום/ה כמדריך/ה',
  'label.you_have_finished_aj_now_send_to_approval': 'המסע האתגרי שלך הושלם. עכשיו תוכל/י להעביר את הפרטים לאישור המדריכ/ה. בנוסף ניתן להוסיף הערה אישית למטה. ',
  'label.your_experience': 'הניסיון שלך',
  'label.your_qualification': 'ההסמכה שלך',
  'notifications.waiting_for_assessor_approval': 'ממתין לאישור המדריך/ה',
  'button.resend_assessment_request': 'שלח/י מחדש בקשת הערכה',
  'errors.emails_must_be_different': 'תיבת הדוא"ל המשנית צריכה להיות שונה מתיבת הדוא"ל הראשונית',
  'moduleTitle.company_details': 'פרטי החברה',
  'notifications.already_resent_assessment_request': 'בקשת ההערכה כבר נשלחה',
  'route.assessor_dashboard': '',
  'pageTitle.register_assessor': 'רישום מדריך/ה',
  'wizard.assessor_details': 'פרטי מדריך/ה',
  'wizard.assessor_experience': 'ניסיון המדריך/ה',
  'wizard.personal_details': 'פרטים אישיים',
  'button.sign_off': 'אישור סופי\n',
  'button.sign_off_dashed': 'אישור סופי',
  'moduleTitle.sign_off': 'אישור סופי\n',
  'label.certify_participant_met_reqs': 'אני מאשר/ת בתור מדריכ/ת החניך/ה שהוא/היא השלימ/ה את פעילותו/ה לפי הדרישות.',
  'label.assessor_report': 'דו"ח מדריך/ה',
  'label.content_update': 'נא להמתין. עדכון תכולה',
  'label.comment_on_participant_improvement': '',
  'note.edit_participant_review': 'בכדי לשנות כל דבר מהמידע הנתון יש ללחוץ על לחצן עריכה',
  'errors.min_age': 'הגיל המינימלי הוא {age}',
  'notifications.assessor_link_expired': '',
  'label.secondary_email': 'דוא"ל חלופי',
  'moduleTitle.review_participant_info': '',
  'label.loading_payment_gateway': '',
  'label.consent_given_login_as_child': '',
  'notifications.only_one_qualification_journey_per_award': '',
  'label.registration_fees_participant': '',
  'moduleTitle.leader_details': 'פרטי הרכז/ת',
  'label.leader_name': 'שם הרכז/ת',
  'label.leader_phone': 'מספר טלפון של הרכז/ת',
  'label.leader_email': 'דואר אלקטרוני של הרכז/ת',
  'moduleTitle.au_details': 'פרטי הסניף',
  'label.au_name': 'שם הסניף',
  'label.assessor_guidelines': 'קווים מנחים',
  'label.assessor_cond_req': '',
  'label.assessor_ref_handbook': '',
  'label.assessor_ref_online_modules': '',
  'label.participant_has_no_aj_report': 'החניכ/ה עדיין לא הגיש/ה טופס',
  'moduleTitle.participant_details': 'פרטי החניכ/ה',
  'label.participants_has_no_logs': 'לחניך/כה אין רישומים עדיין.',
  'label.location_type': '',
  'label.activity_ready_for_signoff': 'הפעילות הזו מוכנה לאישור סופי',
  'label.activities': 'פעילויות',
  'label.choose_how_you_want_to_login': 'בחר/י כיצד תרצה/י להתחבר',
  'roles.leader': 'רכז/ת',
  'roles.award_verifier': '',
  'roles.coordinator': '',
  'roles.aj_assessor': '',
  'roles.aj_supervisor': '',
  'roles.instructor': '',
  'roles.nao_staff': '',
  'roles.super_user': '',
  'roles.user': 'משתמש/ת',
  'roles.viewer': '',
  'roles.authorizing_contact': '',
  'roles.if_staff_superuser': '',
  'roles.if_staff_statistical_user': '',
  'roles.if_staff_viewer': '',
  'roles.aj_instructor': '',
  'label.if_you_have_questions_au': 'אם יש לך שאלות בנוגע להרשמתך, אנא צור קשר עם הסניף שלך.\n',
  'label.we_will_send_you_an_email_leader': 'יישלח אליך דוא"ל כאשר הרשמתך תאושר.',
  'moduleTitle.rejecting_assessor_invitation': '',
  'notifications.assessor_invitation_rejected': '',
  'moduleTitle.participants_list_is_empty': 'רשימת החניכ/ה ריקה',
  'label.note_from_participant': 'הודעה מחניכ/ה',
  'label.you_can_send_aj_to_leader': 'כעט תוכל/י לשלוח את פרטי המסע האתגרי שלך לרכז/ת לאישור.',
  'button.save_report': 'שמור/י דו"ח ',
  'label.this_activity_has_no_assessor': 'לתחום זה לא מצוינים פרטי המדריכ/ה. עליך למלא את פרטי המדריכ/ה לפני שאת/ה שולח/ת את הפעילות לאישור',
  'label.activity_rejected_click_by_assessor': '',
  'button.reject': 'דחה/י',
  'button.reject_invitation': 'דחה/י הזמנה',
  'label.reason': 'סיבה',
  'label.accept_invitation_and_continue': 'אשר/י הזמנה והמשכ/י ',
  'pageTitle.registration_reject': '',
  'errors.you_must_be_older_than_register_for_leader': 'עליך להיות בוגר מ {years} שנים ו{months} חודשים כדי להירשם כרכז סניף.',
  'label.your_report_approve_now_send_to_leader_without_note': '',
  'button.stop_assessing_this_activity': '',
  'button.confirm': 'אשר/י\n',
  'moduleTitle.are_you_sure': 'האם את/ה בטוח/ה?',
  'label.content_restore': '',
  'button.stop_editing': 'הפסק/י לערוך',
  'notifications.activity_has_been_rejected': 'הפעילות נדחתה',
  'notifications.aj_has_been_rejected': 'המסע האתגרי נדחה.',
  'notifications.rp_has_been_rejected': '',
  'moduleTitle.additional_files': '',
  'moduleTitle.no_additional_files': '',
  'moduleTitle.stop_assessing_section': '',
  'label.show_security_and_refund_policy': '',
  'moduleTitle.security_and_refund_policy': '',
  'label.fees_payment': '',
  'label.redund_policy': '',
  'label.security_policy': '',
  'label.leave_blank': 'השאר/י ריק',
  'label.frequently_asked_questions': 'שאלות הנשאלות לעתים קרובות (שו"ת) ',
  'label.language_selection_is_disabled_for_iac': '',
  'errors.min_nights_required': '',
  'label.completion_date': 'תאריך השלמה',
  'label.you_are_offline': '',
  'errors.start_date_after_award_start': 'תאריך ההתחלה אינו יכול להיות לפני שהשלב הנוכחי התחיל',
  'label.participants': 'חניכים/ות',
  'label.marketing_from_iaf': '',
  'label.marketing_from_oa': '',
  'label.marketing_from_nao': '',
  'label.select_iac': '',
  'label.you_will_be_redirected_to_the_paypal_payment': '',
  'notifications.report_has_been_sent': 'הדוח נשלח',
  'label.processing_paypal_payment': '',
  'label.loading_paypal_gateway': '',
  'label.payment_failed': 'התשלום נכשל',
  'label.payment_has_been_cancelled': '',
  'roles.naa_oa_staff': '',
  'label.download_report_and_upload_signed_version': '',
  'button.download_summary_for_assessor': '',
  'label.pay_online_mastercard': '',
  'label.pay_online_paypal': '',
  'notifications.authorization_code_is_missing': '',
  'errors.unknown_payment_error': '',
  'errors.already_in_use_by_auth_contact': '',
  'roles.if_staff_stat_user': '',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': '',
  'announcement.survey_description.do_think_people_are_lazy': '',
  'announcement.survey_title.join_our_global_survey': '',
  'announcement.survey_button.if_below_25': '',
  'announcement.survey_button.if_over_25': '',
  'moduleTitle.privacy_and_cookie_policy': '',
  'label.we_have_made_some_important_changes': '',
  'button.i_agree': '',
  'button.see_more_details': '',
  'label.the_cookie_settings_on_this': ''
}
